// extracted by mini-css-extract-plugin
export var active = "_5t-a";
export var activeIndicator = "_5t-9";
export var disabled = "_5t-b";
export var fullWidth = "_5t-2";
export var lg = "_5t-7";
export var md = "_5t-6";
export var redoButtonTabGroup = "_5t-0";
export var sm = "_5t-5";
export var tabButton = "_5t-4";
export var tabButtonsContainer = "_5t-1";
export var themeDestructive = "_5t-d";
export var themeNormal = "_5t-c";
export var themeSuccess = "_5t-e";
export var xl = "_5t-8";
export var xs = "_5t-3";